import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/stop`,
    request: {} as API.Central.V3.ContentDestinations.Post.Stop.Request,
    responseSchema: API.Central.V3.ContentDestinations.Post.Stop,
    method: HTTP_METHODS.POST,
  },
};
